<template>
    <div class="tc-notifications-anchor">
        <div class="tc-notifications-container">
            <div class="tc-notification"
                 v-if="lastNotification"
                 v-show="lastNotification.visible">
                <div class="tc-notification-text">
                    {{lastNotification.text}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useStoreNotifications } from '@/Store/storeNotifications';

export default {
    name: 'Notifications',
    components: {

    },
    setup() {
        const storeNotifications = useStoreNotifications();
        return {
            storeNotifications,
        };
    },
    computed: {
        lastNotification() {
            const notification = this.storeNotifications.getLastNotification;

            if (!notification) {
                return undefined;
            }

            return notification;
        },
    },
};
</script>

<style scoped lang="scss">
.tc-notifications-anchor {
    position: fixed;
    height: 0;
    width: 100%;
    display: flex;
    //justify-content: center;
    justify-content: center;
    align-items: center;
}

.tc-notifications-container {
    position: relative;
    top: 95px;
    left: -10px;
    z-index: 200;
    width: max-content;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    height: max-content;
}

.tc-notification {
    min-width: 300px;
    //padding: 20px 50px;
    max-width: 500px;
    min-height: 50px;
    width: max-content;
    box-sizing: border-box;
    display: grid;
    grid-auto-flow: column dense;
    grid-column-gap: 15px;
    background-color: #ffffff;
    color: #333333;
    align-items: center;
    justify-content: center;
    transition: 0.3s ease-in-out all;
    pointer-events: all;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}

.tc-notification-text {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    max-width: 500px;
    line-height: 20px;
    padding-top: 3px;
}
</style>
